export const navLinks = [
  { label: '热门档案', href: '#archive' },
  { label: '事件脉络', href: '#timeline' },
  { label: '分类索引', href: '#topics' },
  { label: '爆料速递', href: '#feed' },
  { label: '信源说明', href: '#trust' },
  { label: '常见问题', href: '#faq' },
];

export const heroStats = [
  { value: '3,240+', label: '在册人物档案' },
  { value: '18,600+', label: '整理事件条目' },
  { value: '12,900+', label: '收录信源链接' },
];

export const heroHotTags = [
  '综艺剪辑争议',
  '直播风波',
  '版权纠纷',
  '情感爆料',
  '商业纠纷',
  '言论争议',
  '职场内幕',
];

export const heroTicker = [
  '「顾砚舟」综艺花絮二次剪辑时间线已补齐 3 处信源',
  '「林见晚」代言解约风波新增品牌方公开声明',
  '「陈屿川」直播间口角事件多方回应已归档',
  '「沈墨白」歌词署名争议更新至第 4 轮说明',
  '「苏拾光」秀场合作争议新增现场影像信源',
];

export const focusArchive = {
  code: 'HL-2026-014',
  name: '顾砚舟',
  category: '综艺争议',
  heat: '92.4万',
  updated: '2 小时前',
  title: '「综艺剪辑争议」全时间线：从花絮流出到多方回应',
  summary:
    '一段未播花絮在社交平台流出后引发讨论，随后节目组、经纪团队与当事人先后给出说明。档案已按时间顺序整理 7 个关键节点，并收录 12 条可追溯信源，持续跟进后续回应。',
  points: ['花絮流出与首轮讨论', '节目组剪辑说明', '当事人团队回应', '多方信源交叉印证'],
  cover:
    'https://readdy.ai/api/search-image?query=abstract%20editorial%20artwork%20of%20a%20shadowy%20crowded%20stage%20with%20warm%20amber%20spotlights%20cutting%20through%20atmospheric%20haze%2C%20dark%20charcoal%20gradient%20background%2C%20layered%20geometric%20shapes%20and%20blurred%20silhouettes%2C%20cinematic%20high%20contrast%20moody%20lighting%2C%20soft%20film%20grain%2C%20generous%20negative%20space%2C%20no%20text%2C%20no%20faces&width=900&height=700&seq=hlw-focus-01&orientation=landscape',
};

export const featuredArchive = [
  {
    code: 'HL-2026-011',
    name: '林见晚',
    category: '代言风波',
    heat: '78.1万',
    updated: '5 小时前',
    summary: '合作品牌集中调整对外口径，档案收录双方公开说明与时间节点。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20cover%20style%20abstract%20silhouette%20of%20a%20slender%20figure%20in%20profile%20against%20a%20dark%20charcoal%20textured%20wall%2C%20warm%20amber%20rim%20light%20from%20the%20side%2C%20soft%20film%20grain%2C%20cinematic%20moody%20high%20contrast%2C%20generous%20negative%20space%20on%20the%20right%2C%20magazine%20cover%20aesthetic%2C%20no%20text&width=800&height=1000&seq=hlw-p-02&orientation=portrait',
  },
  {
    code: 'HL-2026-009',
    name: '陈屿川',
    category: '直播口角',
    heat: '71.6万',
    updated: '8 小时前',
    summary: '直播片段被多次搬运，事件脉络与后续道歉说明已整理归档。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20cover%20style%20abstract%20backlit%20silhouette%20of%20a%20broad%20shouldered%20figure%20facing%20away%2C%20deep%20charcoal%20textured%20studio%20backdrop%2C%20warm%20amber%20edge%20lighting%2C%20soft%20film%20grain%2C%20cinematic%20moody%20high%20contrast%2C%20large%20empty%20space%20above%2C%20magazine%20cover%20aesthetic%2C%20no%20text&width=800&height=1000&seq=hlw-p-03&orientation=portrait',
  },
  {
    code: 'HL-2026-007',
    name: '沈墨白',
    category: '版权纠纷',
    heat: '63.9万',
    updated: '11 小时前',
    summary: '作品署名归属引发讨论，平台与版权方说明已同步收录。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20cover%20style%20abstract%20silhouette%20of%20a%20seated%20figure%20holding%20an%20instrument%20shape%2C%20dark%20charcoal%20textured%20wall%2C%20warm%20amber%20rim%20light%20and%20soft%20shadow%2C%20film%20grain%2C%20cinematic%20moody%20high%20contrast%2C%20quiet%20negative%20space%2C%20magazine%20cover%20aesthetic%2C%20no%20text&width=800&height=1000&seq=hlw-p-04&orientation=portrait',
  },
  {
    code: 'HL-2026-006',
    name: '苏拾光',
    category: '秀场争议',
    heat: '58.3万',
    updated: '1 天前',
    summary: '现场影像与工作人员说法存在出入，档案按信源等级分类整理。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20cover%20style%20abstract%20silhouette%20of%20a%20tall%20figure%20mid%20stride%20on%20an%20empty%20runway%2C%20dark%20charcoal%20gradient%20backdrop%2C%20warm%20amber%20backlight%20haze%2C%20soft%20film%20grain%2C%20cinematic%20moody%20high%20contrast%2C%20minimal%20negative%20space%2C%20magazine%20cover%20aesthetic%2C%20no%20text&width=800&height=1000&seq=hlw-p-05&orientation=portrait',
  },
  {
    code: 'HL-2026-004',
    name: '白鹭洲',
    category: '赛事争议',
    heat: '46.7万',
    updated: '1 天前',
    summary: '赛程判罚讨论持续发酵，官方公告与选手表态均已归档。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20cover%20style%20abstract%20silhouette%20of%20a%20hooded%20figure%20seen%20from%20behind%20in%20front%20of%20a%20glowing%20screen%20shape%2C%20dark%20charcoal%20textured%20backdrop%2C%20warm%20amber%20rim%20lighting%2C%20soft%20film%20grain%2C%20cinematic%20moody%20high%20contrast%2C%20negative%20space%2C%20magazine%20cover%20aesthetic%2C%20no%20text&width=800&height=1000&seq=hlw-p-06&orientation=portrait',
  },
  {
    code: 'HL-2026-002',
    name: '程也',
    category: '商业纠纷',
    heat: '41.2万',
    updated: '2 天前',
    summary: '合作款项相关讨论，双方声明与公开往来信息已按时间整理。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20cover%20style%20abstract%20silhouette%20of%20a%20figure%20in%20a%20long%20coat%20standing%20still%2C%20dark%20charcoal%20textured%20wall%2C%20warm%20amber%20side%20light%20and%20long%20shadow%2C%20soft%20film%20grain%2C%20cinematic%20moody%20high%20contrast%2C%20negative%20space%20on%20the%20left%2C%20magazine%20cover%20aesthetic%2C%20no%20text&width=800&height=1000&seq=hlw-p-07&orientation=portrait',
  },
];

export const timelineEvents = [
  {
    date: '09 月 14 日',
    tag: '起于讨论',
    title: '未播花絮流出，首轮讨论出现',
    desc: '一段现场花絮被搬运至多个平台，讨论从片段语境延伸到剪辑方式本身。',
    sources: 5,
  },
  {
    date: '09 月 15 日',
    tag: '节目方回应',
    title: '节目组就剪辑说明发布公开口径',
    desc: '节目组发布说明，解释成片剪辑取舍逻辑，并表示会复核相关片段。',
    sources: 3,
  },
  {
    date: '09 月 16 日',
    tag: '当事人表态',
    title: '当事人团队给出首轮回应',
    desc: '团队回应称尊重剪辑创作，同时希望完整素材语境被一并呈现。',
    sources: 4,
  },
  {
    date: '09 月 18 日',
    tag: '多方信源',
    title: '第三方工作人员说法被收录',
    desc: '两位现场工作人员的说法被整理进档案，与已公开说明交叉比对。',
    sources: 2,
  },
  {
    date: '09 月 20 日',
    tag: '持续跟进',
    title: '讨论焦点转向行业剪辑惯例',
    desc: '话题由个人事件扩散至综艺剪辑惯例，档案新增行业相关背景条目。',
    sources: 6,
  },
];

export const topicIndex = [
  { name: '综艺争议', count: 268, desc: '剪辑、赛制与成片取舍', icon: 'ri-movie-2-line' },
  { name: '直播风波', count: 214, desc: '直播口角与临场失言', icon: 'ri-live-line' },
  { name: '版权纠纷', count: 176, desc: '署名、抄袭与授权争议', icon: 'ri-copyright-line' },
  { name: '情感爆料', count: 322, desc: '关系时间线与知情说法', icon: 'ri-heart-3-line' },
  { name: '商业纠纷', count: 158, desc: '合作款项与合约摩擦', icon: 'ri-briefcase-4-line' },
  { name: '言论争议', count: 241, desc: '公开发言与语境还原', icon: 'ri-chat-quote-line' },
  { name: '职场内幕', count: 139, desc: '团队协作与合约细节', icon: 'ri-building-2-line' },
  { name: '财税风波', count: 96, desc: '公开信息与合规讨论', icon: 'ri-file-list-3-line' },
];

export const updateFeed = [
  {
    time: '18 分钟前',
    tag: '更新',
    title: '顾砚舟 · 综艺花絮争议新增第 12 条信源',
    desc: '补充现场工作人员说法与时间戳比对，事件脉络同步更新。',
    sources: 12,
  },
  {
    time: '1 小时前',
    tag: '新增',
    title: '林见晚 · 代言合作调整事件建立独立档案',
    desc: '收录品牌方公开说明与合作周期信息，按时间顺序整理。',
    sources: 6,
  },
  {
    time: '3 小时前',
    tag: '更新',
    title: '陈屿川 · 直播口角事件补充完整录像回看',
    desc: '对争议片段前后语境进行标注，标注争议起止时间点。',
    sources: 9,
  },
  {
    time: '6 小时前',
    tag: '更正',
    title: '沈墨白 · 署名争议修正一处早期时间节点',
    desc: '依据版权方说明更正登记时间，历史版本保留可追溯记录。',
    sources: 4,
  },
  {
    time: '10 小时前',
    tag: '新增',
    title: '苏拾光 · 秀场合作争议归档现场影像材料',
    desc: '新增两组现场影像与工作人员说法，按信源等级标注。',
    sources: 7,
  },
  {
    time: '昨天',
    tag: '更新',
    title: '白鹭洲 · 赛事判罚讨论收录官方完整公告',
    desc: '补充赛事方公告原文与后续说明，争议点逐条对照。',
    sources: 5,
  },
];

export const hotRank = [
  { rank: 1, name: '顾砚舟', heat: '92.4万', trend: 'up' },
  { rank: 2, name: '林见晚', heat: '78.1万', trend: 'up' },
  { rank: 3, name: '陈屿川', heat: '71.6万', trend: 'flat' },
  { rank: 4, name: '沈墨白', heat: '63.9万', trend: 'up' },
  { rank: 5, name: '苏拾光', heat: '58.3万', trend: 'down' },
  { rank: 6, name: '白鹭洲', heat: '46.7万', trend: 'flat' },
];

export const trustPoints = [
  {
    icon: 'ri-link-m',
    title: '每条结论都挂信源',
    desc: '档案中的关键节点均标注来源链接与收录时间，方便逐条核对原始材料。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '多方说法并列呈现',
    desc: '当事人、平台方与第三方说法分区并列，不做单方面定论，读者自行判断。',
  },
  {
    icon: 'ri-history-line',
    title: '修改留痕可回溯',
    desc: '条目更正会在更新记录中标注变更内容与原因，历史版本保留可追溯。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '投诉与更正通道',
    desc: '涉及事实错误或不实信息，可通过申诉入口提交材料，我们优先复核处理。',
  },
];

export const communityThreads = [
  {
    avatar: '砚',
    nickname: '档案读者·南屿',
    level: 'LV.12',
    time: '32 分钟前',
    content:
      '把花絮和成片放在一起对比看确实更清楚，建议档案里再补一条「剪辑顺序对照」的说明，很多讨论其实卡在语境的先后上。',
    likes: 246,
    replies: 38,
    topic: '事件脉络',
  },
  {
    avatar: '白',
    nickname: '信源观察员',
    level: 'LV.20',
    time: '1 小时前',
    content:
      '这次节目组说明写得挺完整，但时间点用的是「近期」这种模糊表述，档案里最好标注成「说明发布当日」，避免后面转引时又被当成新消息。',
    likes: 189,
    replies: 24,
    topic: '归档建议',
  },
  {
    avatar: '舟',
    nickname: '路过的人',
    level: 'LV.7',
    time: '2 小时前',
    content:
      '第一次来，按人物索引找事件真的快。想问下分类索引里「言论争议」和「职场内幕」会重叠吗？感觉有几条我不知道该归到哪类。',
    likes: 97,
    replies: 15,
    topic: '使用求助',
  },
];

export const faqList = [
  {
    q: '15黑料网 的人物黑料档案是怎么整理的？',
    a: '每条人物档案按「事件—时间线—信源」三层结构归档：先用一段摘要交代事件全貌，再按时间顺序列出关键节点，最后附上可追溯的信源链接与收录时间，方便你按人物索引快速定位并自行核对。',
  },
  {
    q: '档案里的内容会持续更新吗？',
    a: '会。热门人物的争议与负面事件仍在发展时，档案会按热度与进展持续补充节点，更新记录中会注明新增或更正的内容，历史版本保留可追溯。',
  },
  {
    q: '黑历史合集里的说法是否代表本站结论？',
    a: '不代表。我们做的是「多方信源整理」，把当事人、平台方与第三方的说法分区并列呈现，不替任何一方定论，也不鼓励对个人进行人身攻击。',
  },
  {
    q: '如何按人物索引查询某位公众人物的负面事件？',
    a: '在首屏的索引搜索框输入人物名或事件关键词，或直接浏览「热门人物黑料档案」与「分类索引」两个板块，按题材进入对应的档案集合，再沿时间线查看完整事件脉络。',
  },
  {
    q: '如果档案里有不准确的内容怎么办？',
    a: '可以通过信源说明板块的申诉与更正通道提交材料。我们会在收到后优先复核，确认有误的条目会标注更正说明并保留修改留痕，而不是直接静默删除。',
  },
  {
    q: '本站收录的各类爆料可以直接转载吗？',
    a: '档案中的整理文字请注明来源，原始图片与视频版权归原发布方所有。请在转载时保留信源链接，避免脱离语境单独传播，减少二次误读。',
  },
];

export const footerColumns = [
  {
    title: '内容板块',
    links: [
      { label: '热门人物黑料档案', href: '#archive' },
      { label: '事件脉络时间线', href: '#timeline' },
      { label: '黑历史分类索引', href: '#topics' },
      { label: '爆料速递', href: '#feed' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '信源与核实说明', href: '#trust' },
      { label: '常见问题', href: '#faq' },
      { label: '社区讨论', href: '#community' },
      { label: '订阅速递', href: '#subscribe' },
    ],
  },
  {
    title: '参与与反馈',
    links: [
      { label: '提交爆料线索', href: '#subscribe' },
      { label: '申请更正条目', href: '#trust' },
      { label: '归档规范说明', href: '#trust' },
      { label: '联系编辑组', href: '#subscribe' },
    ],
  },
];